@if (showDateHeader) {
    <div class="flex flex-row items-center text-sm font-bold pl-2 pr-3 mb-2 mt-2">
        <div class="grow">{{ actionDate }}</div>
        <input #dateCheckbox (change)="onDateChecked(dateCheckbox.checked)" type="checkbox">
    </div>
}
<div id="tooltip-holder" class="absolute">
    <div #versionTooltip role="tooltip" class="absolute z-30 inline-block w-[171px] h-[240px] shadow rounded-lg left-[-181px] bg-contain invisible"></div>
</div>
<div 
    (mouseenter)="onHoverEnter()" 
    (mouseleave)="onHoverExit()"
    class="flex flex-row gap-2 text-xs sm:text-sm hover:rounded hover:shadow-sm hover:bg-ponder-linkhover hover:bg-opacity-15 items-center pl-2 pr-3"
    [ngClass]="{ 'bg-ponder-linkhover bg-opacity-5' : isChecked }">
    <div class="p-1 ml-2 rounded shadow font-mono text-slate-50 min-w-[4ch] text-center" [ngClass]="{ 'bg-red-700' : actionDelta < 0, 'bg-green-700' : actionDelta > 0}">
        {{ actionDeltaStr }}
    </div>
    <div class="p-1 rounded shadow font-mono text-slate-50 min-w-[4ch] text-center bg-slate-400">
        {{ prevChangeValue }} → {{ postChangeValue }}
    </div>
    <a  href="/item/{{ action.itemId }}" class="p-1 col-span-2 truncate text-ellipsis grow" [ngClass]="{ 'text-foil-dark' : action.specialCountDelta, 'text-slate-500 italic' : action.proxyCountDelta != undefined }">
        {{ action.itemName }}
    </a>
    <div class="p-2 pr-3 text-right w-[8ch]">
        {{ actionTime }}
    </div>
    <input #undoCheckbox (change)="onChecked(undoCheckbox.checked)" type="checkbox">
</div>